import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Queries Product Configurator API to get data from database
export const productConfiguratorApi = createApi({
    reducerPath: 'productConfiguratorApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_BASE
    }),
    endpoints: (builder) => ({
        getArtwork: builder.query({
            query: (name) => `/artwork?name=${name}`
        }),
        getCategories: builder.query({
            query: () => '/categories'
        }),
        getIems: builder.query({
            query: () => `/iems`
        }),
        getShells: builder.query({
            query: () => '/shells'
        }),
        getFaceplates: builder.query({
            query: () => '/faceplates'
        }),
        getCables: builder.query({
            query: () => '/cables'
        }),
        getImp: builder.query({
            query: () => '/impression-statuses'
        }),
        getRush: builder.query({
            query: () => '/rush-processing'
        })
    })
});

export const {
    useGetArtworkQuery,
    useGetCategoriesQuery,
    useGetIemsQuery,
    useGetShellsQuery,
    useGetFaceplatesQuery,
    useGetCablesQuery,
    useGetImpQuery,
    useGetRushQuery
} = productConfiguratorApi;
